export function mapUserForAutocomplete(arr) {
    return arr.map((i) => ({
        id: i.id,
        value: `${i.lastName} ${i.firstName}`,
    }));
}

export function mapTeamsForCalendarModal(teams) {
    return teams.reduce(
        (obj, cur) => {
            obj[cur.id] = cur.name;
            return obj;
        },
        { all: 'All' },
    );
}

export function getGeneralTeamNames(c) {
    if (c.isAllTeams) {
        return 'All';
    }
    if (c.Teams.length === 0) {
        return '(deleted)';
    }
    return '';
}

export function createUsersQuery({ teamId, role, user }) {
    let query = role ? `&role=${role}` : `&role=all`;
    if (teamId) {
        query += `&teamId=${teamId}`;
    }
    if (user) {
        query += `&user=${user.trim()}`;
    }
    return query;
}

export function createSearchQuery(props) {
    let query = [];
    for (let key in props) {
        if (props[key]) {
            query.push(`${key}=${props[key]}`);
        }
    }
    return '&' + query.join('&');
}
export function filterUsers(state, list) {
    const { role, teamId, user } = state;
    let filtered = list;
    if (role) {
        filtered = filtered.filter((u) => u.role === role);
    }
    if (teamId) {
        filtered = filtered.filter(({ Teams }) => Teams.some((t) => t.id === teamId));
    }
    if (user) {
        filtered = filtered.filter(({ fullName }) => fullName.toLowerCase().indexOf(user.toLowerCase()) !== -1);
    }
    return filtered;
}
